import type {PbeSwap} from './types';

export default function pbeTransform<
  TVariables extends Record<string, unknown>,
  TPbe extends Partial<Record<keyof TVariables, string>>,
  TMap extends Readonly<Record<string, ReadonlyArray<string>>>,
>(swap: PbeSwap, vars: TVariables, pbe: TPbe, map: TMap) {
  const copy: Record<string, unknown> = {...vars};

  Object.keys(copy).forEach((key) => {
    if (key in pbe) {
      const list = map[pbe[key] as keyof TMap];

      if (list) {
        copy[key] = pbe[key]?.endsWith('MaybeEmpty')
          ? swap(copy[key], (inner) => change(swap, inner, new Set(list)), key)
          : change(swap, copy[key], new Set(list));
      }
    }
  });

  return copy;
}

function change(
  swap: PbeSwap,
  input: unknown,
  paths: Set<string>,
  base = '',
): unknown {
  if (paths.has(base)) {
    const childPaths = new Set(paths);

    childPaths.delete(base);

    return swap(
      input,
      (inner) => {
        return change(swap, inner, childPaths, base);
      },

      base,
    );
  }

  if (Array.isArray(input)) {
    return input.map((item) => {
      return change(swap, item, paths, base);
    });
  }

  const obj = input;

  if (obj && typeof obj === 'object') {
    const acc: Record<string, unknown> = {...obj};

    Object.keys(acc).forEach((key) => {
      acc[key] = change(swap, acc[key], paths, base ? `${base}.${key}` : key);
    });

    return acc;
  }

  return obj;
}
